module.exports = {
  // 通用部分
  common: {
    dataType: "数据种类",
    tip: "提示",
    orgName: "组织名称",
    searchTip: "请输入关键词搜索",
    contextTip: "请输入内容",
    filterTip: "输入关键字进行过滤",
    choseTip: "请选择",
    other: "其他",
    remarks: "备注",
    all: "全部",
    onLine: "在线",
    offLine: "离线",
    equal: "等于",
    unequal: "不等于",
    date: "日期",
    dateRange: "日期范围",
    to: "至",
    reach: "到",
    starDate: "开始日期",
    endDate: "结束日期",
    nearlyMonth: "近一个月",
    cumulativeTime: "累计时间",
    timeOfTheMonth: "当月时间",
    timeOfTheDay: "当日时间",
    choseTime: "选择时间",
    noData: "暂无数据",
    twentyFourHourSystem: "24小时制",
    eightHourSystem: "8小时制",
    dayUseRate: "日使用率",
    manufactureNum: "制造编号",
    carId: "车辆编号",
    plateNum: "车牌号",
    customNum: "客户自编号",
    orgName: "组织名称",
    terminalId: "终端编号",
    driverNum: "驾驶证号",
    messageTime: "上报时间",
    linkState: "设备状态",
    createTime: "操作日期",
    lastUser: "操作人员",
    brand: "品牌",
    model: "型号",
    updateTime: "更新时间",
    setUpTime: "创建时间",
    driverName: "司机姓名",
    remark: "备注",
    num: "编号",
    id: "序号",
    companyName: "公司名称",
    picture: "图片",
    normal: "正常",
    abnormal: "异常",
    nearTime: "临期",
    exceedTime: "超期",
    province: "省份",
    city: "城市",
    address: "地址",
    number: "数量",
    registrationCode: "注册代码",
    externalNumber: "外部编号",
    scrap: "报废",
    form: {
      orgName: "选择组织",
      orgTip: "请选择部门",
      rolePower: "请选择角色",
      roleData: "数据权限",
      choseTip: "请选择",
      state: "请选择设备状态",
      terminalId: "请输入终端编号",
      terminalType: "请选择终端类型",
      groupId: "请选择终端上传类型",
      keyId: "请选择指令名称",
      dirver: "请选择司机",
      group: "请选择班组",
      email: "请输入邮箱",
      sort: "请输入正确的排序",
    },
    btn: {
      search: "查询",
      replace: "替换",
      confirmReplace: "确定替换吗？",
      replaceSuccess: "替换成功",
      add: "新建",
      addSuccess: "新建成功",
      edit: "编辑",
      editSuccess: "修改成功",
      delete: "删除",
      confirmDelete: "确定删除吗?",
      deleteSuccess: "删除成功",
      confirmReset: "确定重置吗?",
      resetPass: "重置密码",
      resetPassSuccess: "重置成功",
      refresh: "刷新",
      refreshSuccess: "刷新成功",
      hint: "提示",
      confirm: "确定",
      cancel: "取消",
      confirmCancel: "确定取消吗？",
      cancelSuccess: "取消成功",
      batchUpload: "批量导入",
      batchDelete: "批量删除",
      upload: "导入",
      download: "导出",
      detail: "详情",
      operate: "操作",
      downloadFile: "下载附件",
      downloadModelFile: "模板文件下载",
      uploadFile: "上传附件",
      clickUploadFile: "点击上传文件",
      choseExcelFile: "请选择Excel格式的文件导入！",
      bind: "绑定",
      bindSuccess: "绑定成功",
      unBind: "解绑",
      unBindSuccess: "解除成功",
      transferSuccess: "划拨成功",
      transfer: "划拨",
      clear: "清空",
      sync: "同步",
      confirmClear: "确定清空吗？",
      clearSuccess: "清空成功",
      confirmSubmit: "确定提交吗？",
      submitSuccess: "提交成功",
      refreshSuccess: "刷新成功",
      authSuccess: "授权成功",
      submit: "提交",
      goback: "返回",
      listsetting: "列配置",
      choseDate: "请选择日期",
      uploadPicture: "请上传图片",
      fileUploadSuccess: "上传文件成功",
      fileUploadError: "上传文件失败",
      bindText: "此操作将解除绑定，是否继续？",
      rolePower: "角色权限",
      roleData: "数据权限",
      operateDetail: "操作详情",
      click: "点击",
      clickUpload: "点击上传",
      onlyUploadxlsOrxlsx: "只能上传xls/xlsx文件",
    },
    search: {
      whole: "全部",
      dateSearch: "选择日期",
      outWarranty: "质保期外",
      inWarranty: "质保期内",
    }
  },
  //登录
  Login: {
    title: "朗云智慧车队管理系统",
    login: "登录",
    forgetPass: "忘记密码?",
    loginName: "账号",
    loginNameMessage: "请输入用户名",
    loginPwd: "密码",
    loginPwdMessage: "请输入密码",
  },
  //置顶栏
  TopBar: {
    home: "首页",
    pass: "修改密码",
    exit: "退出系统",
    oldPass: "原密码",
    newPass: "新密码",
    message: "消息",
    carCurrentFault: "车辆当前故障",
    driverCurrentViolation: "司机当前违规",
    carIdOrManufactureNum: "车辆编号/制造编号",
    faultType: "故障类型",
    faultTime: "故障时间",
    driverNumOrDriverName: "驾驶证号/司机姓名",
    violationType: "违规类型",
    violationTime: "违规时间",
    contactName: "报修人",
    happenTime: "报修时间",
    phone: "联系电话",
    describe: "情况描述",
    en: "英文",
    eventMessage: "故障类型",
    startTime: "发生时间",
    handleState: "处理状态",
    noHandle: "未处理",
    handle: "已处理",
    ignored: "已忽略",
    push: "推送",
    repair: "报修",

    form: {
      confirmPass: "确认密码",
      imputPass: "请输入密码",
      imputPassAgain: "请再次输入密码",
      passDifferent: "两次输入密码不一致!",
      carId: "请输入车辆编号",
      contactName: "请输入报修人",
      happenTime: "请选择报修时间",
      phone: "请输入联系电话",
      yourBrowserDoesNotSupportFullScreen: "你的浏览器不支持全屏",
      confirmIgnore: "确定忽略吗？",
      ignoreSuccess: "忽略成功",
      confirmPush: "确定推送吗？",
      pushSuccess: "推送成功",
    },
    btn: {
      selfSet: "自定义配置",
      ignore: "忽略",
    }
  },
  //菜单
  NavMenu: {
    home: "首页",
    VehicleManagement: "车辆管理",
    VehicleFiles: "车辆档案",
    VehicleAnnualReview: "车辆年审",
    VehicleStatus: "车辆状态",
    VehicleDistribution: "车辆分布",
    VehicleTrajectory: "车辆轨迹",
    ElectricFence: "电子围栏",
    CloudFence: "云围栏",
    EquipmentControl: "设备控制",
    MaintainManagement: "维修管理",
    MaintenanceProgram: "保养项目",
    MaintenanceManagement: "保养管理",
    InsureFile: "保险档案",

    DriverManagement: "司机管理",
    DriverFile: "司机档案",
    DriverAnnualReview: "司机年审",
    DriverStatus: "司机状态",
    KeyFile: "IC卡档案",
    DriverFingerprintFile: "司机指纹档案",
    NewDriverFingerprintFile: "司机指纹档案(新)",
    FingerprintLibraryFile: "指纹库档案",
    AuthorizationManagement: "司机现场授权",
    DriverAuthorizationManagement: "司机远程授权",
    FingerprintAuthorization: "指纹库远程授权",
    DriverFaceFile: "司机人脸档案",
    ICEmpower: "IC卡授权管理",
    FaceAuthorize: "人脸授权",
    DriverTrain: "司机培训",
    DriverTeam: "司机班组",

    BatteryManagement: "电池管理",
    BatteryFile: "电池档案",
    BatteryStatus: "电池状态",

    SafeManagement: "安全管理",
    FaultManagement: "故障管控",
    ViolationControl: "违规管控",

    DataAnalysis: "效率分析",
    VehicleAnalysis: "车辆分析",
    VehicleEfficiencySummary: "车辆效率总表",
    Efficiency: "车辆效率分析",
    Duration: "车辆时长分析",
    Fault: "车辆故障分析",
    DriverAnalysis: "司机分析",
    DriverComprehensive: "司机效率总表",
    DriverEfficiency: "司机效率分析",
    DriverDuration: "司机时长分析",
    DriverViolation: "司机违规分析",
    BatteryAnalysis: "电池分析",
    MaintenanceAnalysis: "维保分析",
    CarCheck: "车辆点检",
    VehicleOrgReport: "车辆班组报表",
    DriverOrgReport: "司机班组报表",

    PlatformSettings: "系统设置",
    userManagement: "用户管理",
    roleManagement: "角色管理",
    MenuManagement: "菜单管理",
    organizaManagement: "组织管理",
    dictionaryManagement: "品牌型号管理",
    checkManagement: "点检项管理",
    ReportPush: "报表推送",

    BackgroundSettings: "后台设置",
    TerminalCommand: "终端命令",
    CompanyManagement: "公司管理",
    JurisdictionalManagement: "辖区管理",
    OTAManagement: "OTA管理",
    DictionaryManaged: "字典管理",
    DictionaryItem: "字典项目",
    TerminalFile: "终端档案",
    SIMFile: "SIM卡档案",
    ExternalEqu: "外部设备",
    EquipmentRenewal: "设备续费",

    AccounManagement: "商务管理",
    ContractManagement: "合同管理",

    GovernmentRegulation: "政府监管",
    JurisdictionalCompanies: "辖区管辖公司",
    JurisdictionalCar: "辖区车辆查询",
    JurisdictionalDriver: "辖区司机查询",
    JurisdictionalAnalysis: "辖区分析",
    Comprehensive: "综合分析",
    Secure: "安全分析",
    EnforcementNotes: "执法笔记",
    NoteDetail: "笔记详情",
    PolicyRule: "政策法规",
    AnnualReview: "年审审批",

  },
  //合同管理
  ContractManagement: {
    contractId: "合同编号",
    typeName: "合同类型",
    supplierName: "供应商",
    contactName: "联系人",
    phone: "联系电话",
    signTime: "签订日期",
    warrantyTime: "质保日期",
    isWarranty: "质保状态",
    contractMoney: "合同金额",
    form: {
      contractIdTip: "请输入合同编号",
      signTimeTip: "请选择签订时间",
      warrantyTimeTip: "请选择质保时间",
      typeNameTip: "请选择合同类型",
      sale: "销售合同",
      buy: "采购合同",
    },
    search: {
      warrantyTime: "请选择质保状态",
    }
  },
  //后台设置-公司管理
  CompanyManagement: {
    companyNum: "统一社会信用代码",
    name: "公司名称",
    companyAddress: "公司地址",
    logoPath: "公司logo",
    companyRole: "公司角色",
    homepageUrlNumber: "首页地址",
    companyInform: "公司信息",
    loginInform: "管理员信息",
    safeInform: "安全员信息",
    loginName: "公司管理员账户",
    safeLoginName: "公司安全员账户",
    safeUserName: "安全员名称",
    createTime: "创建日期",
    updateTime: "更新日期",
    lastUser: "操作人员",
    bindOrg: "组织绑定",
    editAdmin: "修改管理员",

    companyDetails: "公司详情",
    manageAccount: "管理员账号",
    mail: "管理员邮箱",
    CompanyLogo: "公司logo",
    manager: "管理员名称",
    setPosition: "位置设置",
    companyRole: "公司权限",


    form: {
      name: "请输入公司名称",
      email: "管理员邮箱",
      safeEmail: "安全员邮箱",
      resetPass: "重置密码",
      homepageUrlNumber: "请选择首页地址",
      loginName: "请输入管理账号",
      userName: "请输入管理名称",
      safeLoginName: "请输入安全员账户",
      safeUserName: "请输入安全员名称",
      orgTree: "查找组织树",
      menu: "平台页面权限",
      appMenu: "APP页面权限",
      companyLogoTip: "（logo宽为146px，高为51px）",
      selectCenterAndLevel: "获取地图中心点和层级"
    },
    btn: {
      changeRole: "修改公司权限",
      changeCompany: "选择公司",
      resetPassword: "重置密码",

      selectPostion: "选择中心点",
      companyRole: "修改公司权限",
      getCurrentLevel: "获取当前级别"
    }
  },
  //后台设置-字典管理
  DictionaryManaged: {
    dictId: "字典编码",
    dictValue: "字典值",
    dictAdditionalValue: "附加信息",
    dictSort: "字典排序",
    remarks: "备注",
    createTime: "创建时间",
    id: "字典编号",
    dictName: "字典名称",
    dictType: "字典类型",
    form: {
      dictValue: "请输入字典值",
      keyword: "请输入关键词搜索",
      dictName: "请输入字典名称",
      dictType: "请输入字典类型",
    },
  },
  //后台设置-外部设备
  ExternalEqu: {
    all: "全部",
    externalId: "外部设备编号",
    carId: "车辆编号",
    terminalId: "终端编号",
    externalTypeStr: "设备类型",
    externalType: "设备类型",
    remarks: "备注",
    id: "编号",
    equIMEINumber: "设备IMEI号",
    form: {
      terminalId: "请输入外部设备编号",
      typeId: "请选择设备类型",
    },
  },
  //后台设置-辖区管理
  JurisdictionalManagement: {
    resetPassSuccess: "重置密码成功",
    add: "添加辖区",
    edit: "修改详情",
    jurisdictionNum: "辖区编号",
    jurisdictionName: "辖区名称",
    loginName: "管理账号",
    userName: "管理名称",
    logoPath: "辖区logo",
    email: "管理邮箱",
    editAdmin: "修改管理员",
    updateUser: "操作人员",
    updateTime: "更新时间",
    menu: "平台页面权限",
    appMenu: "APP页面权限",
    choseJurisdiction: "选择辖区",
    jurisdictionInform: "辖区信息",
    email: "管理邮箱",
    editRole: "修改管理员权限",
    resetTip: "此操作将重置该用户密码，是否继续？",
    resetPassword: "重置后的密码为：",
    form: {
      jurisdictionName: "请输入辖区名称",
      jurisdictionNum: "请输入辖区编号",
      loginName: "请输入管理账号",
      userName: "请输入管理名称",
    },
  },
  //后台设置-OTA管理
  OTAManagement: {
    issue: "发布",
    ubIssue: "未发布",
    unpublish: "取消发布",
    state: "状态",
    typeIdStr: "终端类型",
    firmwareVersion: "版本号",
    createTime: "创建时间",
    updateTime: "发布时间",
    lastUser: "操作人员",
    describe: "描述",
    isConfirmIssue: "是否确定要发布",
    isConfirmCancelIssue: "是否确定要取消发布",
    issueSuccess: "发布成功",
    cancelIssueSuccess: "发布成功",
    groupId: "终端上传类型",
    uploadFile: "上传终端文件",
    addTermianlSetting: "添加终端配置",
    defaultVersion: "默认版本",
    form: {
      no: "请输入版本号",
      uploadFile: "请上传固件包",
      groupId: "请选择终端上传类型",
      typeId: "请选择终端类型",
      terminalId: "请选择终端",
      uploadTerminal: "导入终端",
      uploadTerminalFile: "上传终端文件",
      describe: "描述",
    },
    btn: {
      addOTA: "新建OTA版本",
      downloadFile: "模板下载",
      clickToUploadFile: "点击上传",
      changeRole: "点击上传",
      onlySpecialFile: "只能上传xls/xlsx文件",
    }
  },
  //后台设置-终端命令
  TerminalCommand: {
    terminalType: "终端型号",
    productNumber: "产品型号",
    name: "指令内容",
    aliKey: "指令标识符",
    keyType: "指令类型",
    sort: '排序',
    explain: "指令说明",
    terminalModel: "终端型号:",
    newModel: "新建型号",
    InsContent: "指令内容:",
    InsIdentifier: "指令标识符:",
    InsType: "指令类型",
    Instructions: "指令说明",
    begin: "启用",
    state: "操作",
    stop: "禁用",
    beginSuccess: "启用成功",
    stopSuccess: "禁用成功",
    choseTip: "请选择",
    attSetting: "属性设置",
    servSetting: "服务设置",
    unit: "单位",
    isShow: "隐藏显示",
    hidden: "隐藏",
    show: "显示",
    form: {
      terminalType: "请输入终端型号",
      productKey: "请输入产品型号",
      name: "请输入指令内容",
      aliKey: "请输入指令标识符",
      keyType: "请选择指令类型",
      sort: "请选择排序",
      unit: "请输入单位",
      isShow: "请选择隐藏显示",
    },
    btn: {
    }
  },
  //后台设置-终端档案
  TerminalFile: {
    terminalId: "终端编号",
    typeId: "终端类型",
    terminalModel: "终端型号",
    firmwareVersion: "固件版本",
    deliveryTime: "出厂日期",
    simIccicd: "ICCID号",
    expirationDate: '质保日期',
    expirationState: "质保状态",
    unPush: "不推送",
    push: "推送",
    pastDue: "过期状态",
    form: {
      terminalId: "请输入终端编号",
      typeId: "请选择终端类型",
      deliveryTime: "请选择出厂时间",
      choseExcel: "请选择Excel格式的文件导入！",
      pushState: "是否推送",
      choseCarType: "请选择车型",
    },
    btn: {
    }
  },
  EquipmentRenewal: {
    type: "种类",
    feeType: "收费类型",
    chargingStatus: "收费状态",
    feeRemarks: "收费备注",
    usageStatus: "使用状态",
    feeStandards: "收费标准",
    chargeStartDate: "收费开始日期",
    lastPaymentDate: "上次缴费日期",
    expirationDate: "到期日期",
    chargingStatus: "收费状态",
    changeOfChargingType: "收费类型变更",
    batchRenewal: "批量续费",
    batchScrapping: "批量报废",
    charge: "收费",
    noCharge: "不收费",
    changeSuccessful: "变更成功",
    uploadFiles: "上传文件",
    RenewalTemplateDownload: "续费模板下载",
    scrapTemplateDownload: "报废模板下载"
  },
  
  SIMFile: {
    assetStatus: "资产状态",
    inUse: "在用",
    abandoned: "废弃",
    cardStatus: "卡状态",
    activationDate: "激活日期",
    expirationDate: "过期日期",
    operators: "运营商",
    cardUsage: "当月卡用量",
    syncTime: "同步时间",
    enterIccicd: "请输入ICCID号",
    enterSupplier: "请输入供应商",
    modifyRemarks: "修改备注",
    SIMCardScrapping: "SIM卡报废",
    abandonedSuccessfully: "废弃成功",
  },
  //电池管理-电池档案
  BatteryFile: {
    batteryNumber: "电池编号",
    carId: "车辆编号",
    terminalId: "终端编号",
    orgName: "组织名称",
    batteryType: "电池类型",
    power: "额定电压(V)",
    capacity: "额定容量(Ah)",
    ratedChargingSpeed: "额定充电阈值(%/h)",
    ratedDischargeSpeed: "额定放电阈值(%/h)",
    plumbicAcid: "铅酸",
    lithium: "锂电",
    transferDialong: "电池划拨",
    batteryNumber: "电池编号-归属",
    roleId: "目标位置",
    addDialong: "绑定车辆",
    form: {
      terminalId: "请输入终端编号",
      typeId: "请选择终端类型",
      batteryType: "请选择电池类型",
    },
    btn: {
    }
  },
  //电池管理-电池状态
  BatteryStatus: {
    batteryNumber: "电池编号",
    carId: "车辆编号",
    terminalId: "终端编号",
    orgName: "组织名称",
    batteryType: "电池类型",
    power: "额定电压(V)",
    voltage: "电压",
    batteryInform: "电池信息",
    batteryPower: "电压",
    batteryElectricity: "电量",
    capacity: "额定容量(Ah)",
    ratedChargingSpeed: "额定放电阈值(v/min)",
    ratedDischargeSpeed: "额定充电阈值(%/h)",
    baseInform: "基本资料",
    to: "至",
    starDate: "开始日期",
    endDate: "结束日期",
    chargeAndDischarge: "充放电",
    chargeAndDischargeRecord: "充放电记录",
    batteryVoltageRecord: "电池电压记录",
    charge: "充电",
    discharge: "放电",
    isWarning: "损耗状态",
    batteryWarning: "损耗状态",
    normal: "正常",
    abnormal: "异常",
    happenTime: "开始时间",
    trouble: "故障",
    endTime: "结束时间",
    happenElectricity: "开始电量(%)",
    endElectricity: "结束电量(%)",
    continuedTime: "持续时间(H)",
    judgeRate: "判断阈值",
    rate: "实际值",
    chargeType: "类型",
    dateRange: "日期范围",
    noData: "暂无数据",
    leisure: "空闲",
    work: "工作",
    messageTime: "上报时间",
    batteryState: "工作状态",
    plumbicAcid: "铅酸",
    lithium: "锂电",
    form: {
      batteryState: "请选择工作状态",
      batteryWarning: "请选择损耗状态",
      batteryType: "请选择电池类型",
    },
    btn: {
    }
  },
  //效率分析-电池分析
  BatteryAnalysis: {
    batteryNumber: "电池编号",
    carId: "车辆编号",
    terminalId: "终端编号",
    orgName: "组织名称",
    chargeTimeH: "设备充电时长",
    chargeTime: "充电时长",
    chargeCount: "充电次数",
    dischargeTime: "放电时长",
    dischargeCount: "放电次数",
    dischargeTimeH: "设备放电时长",
    warningCount: "异常次数",
    warningCountH: "设备异常次数",
    happenTime: "开始时间",
    endTime: "结束时间",
    happenElectricity: "开始电量",
    endElectricity: "结束电量",
    eventInterval: "持续时间",
    judgeRate: "判断阈值",
    isWarningStr: "损耗状态",
    eventInterval: "实际阈值",
    chargeTypeStr: "类型",
    count: "次数",
    duration: "时长",
    date: "日期",
    to: "至",
    starDate: "开始日期",
    endDate: "结束日期",
    chargeAndDischargeTimeH: "充放电次数时长",
    carUseDetail: "车辆使用明细",
    normal: "正常",
    abnormal: "异常",
    rate: "使用率",
    form: {
      batteryNumber: "请输入电池编号",
      carId: "请输入车辆编号",
      batteryType: "请选择电池类型",
    },
    btn: {
    }
  },
  //效率分析-司机分析
  DriverAnalysis: {
    driverNum: "驾驶证号",
    driverNo: "驾驶编号",
    name: "司机姓名",
    carId: "车辆编号",
    terminalId: "终端编号",
    workTime: "统计内使用时长",
    todayWork: "今日工时",
    orgName: "组织名称",
    // workTimeH: "累计使用时长",
    cardCount: "统计内刷卡次数",
    cardCountH: "累计刷卡次数",
    alarmCount: "统计内违规次数",
    alarmCountH: "累计违规次数",
    driverName: "司机姓名",
    swipesRank: "刷卡次数排名",
    noData: "暂无数据",
    workTimeH: "工作时长(小时H)",
    violationRank: "违规次数排名",
    happenElectricity: "开始电量",
    endElectricity: "结束电量",
    eventInterval: "持续时间",
    judgeRate: "判断阈值",
    isWarningStr: "损耗状态",
    eventInterval: "实际阈值",
    chargeTypeStr: "类型",
    count: "次数",
    duration: "时长",
    date: "日期",
    to: "至",
    driverWorkRecord: "司机工作记录",
    starDate: "开始日期",
    endDate: "结束日期",
    timOfTheDay: "当日时间",
    nearlyMonth: "近一个月",
    cumulativeTime: "累计时间",
    choseTime: "选择时间",
    workHour: "工作时长",
    useTimeRate: "工作效率",
    startTime: "开机时间",
    endTime: "关机时间",
    useRate: "使用率",
    userTime: "使用时长",
    dailyCarHour: "每日车辆时长",
    dailyWorkHour: "每日工作时长",
    dayUseRate: "日使用率",
    dayUseTime: "日使用时长",
    twentyFourHourSystem: "24小时制",
    eightHourSystem: "8小时制",
    driverWorkCollect: "驾驶员工作汇总",
    moveTime: "移动时长",
    carryWeightTime: "负载时长",
    freeTime: "空闲时长",
    moveLoadRate: "移动负载效率",
    carryDuration: "负载时长",
    freeDuration: "空闲时长",
    rate: "使用率",
    dailyCarRate: "每日车辆效率",
    driverWorkDetail: "驾驶员工作明细",
    totalWorkHour: "总工时",
    overloadCount: "超载",
    speedOverCount: "超速",
    outPositionCount: "离位超时",
    collisionCount: "碰撞",
    leaveFenceCount: "出围栏",
    violationTime: "违规时间",
    eventMessage: "违规类型",
    value: "数量(次)",
    todayVolation: "今日违规",
    violationTrend: "违规趋势",
    violationProp: "违规占比",
    violationDetail: "违规明细",
    form: {
      driverNum: "请输入驾驶证号",
      name: "请输入司机姓名",
      driverName: "请输入司机姓名",
    },
    btn: {
    }
  },
  //效率分析-维保分析
  MaintenanceAnalysis: {
    batteryNumber: "电池编号",
    carId: "车辆编号",
    terminalId: "终端编号",
    orgName: "组织名称",
    maintainPeopleCost: "保养人工费用",
    maintainMaterialCost: "保养物件费用",
    maintainCount: "保养次数",
    repairCount: "维修次数",
    repairPeopleCost: "维修人工费用",
    repairMaterialCost: "维修物件费用",
    repairCostRate: "维修费用占比率",
    maintainCostRate: "保养费用占比率",
    yuan: "元",
    moneyYuan: "金额(元)",
    lastYearMaintainCost: "去年维保总费用",
    thisYearMaintainCost: "今年维保总费用",
    yearOnYearGrowthRate: "同比增长率",
    monthOnMonthGrowthRate: "环比增长率",
    riseRate: "增长率",
    repairCostCompar: "维保费用对比",
    form: {
      carId: "请输入车辆编号",
    },
    btn: {
    }
  },
  //效率分析-车辆分析
  VehicleAnalysis: {
    manufactureNum: "制造编号",
    carId: "车辆编号",
    plateNum: "车牌号",
    customNum: "自编号",
    orgName: "组织名称",
    terminalId: "终端编号",
    startStopTime: "启停次数",
    stopCountH: "累计启停次数",
    workTime: "统计内使用时长",
    workTimeH: "累计使用时长",
    problemCount: "统计内故障次数",
    faultFrequency: "故障次数",
    problemCountH: "累计故障次数",
    rank: "起停次数排名",
    useTimeH: "使用时长(小时H)",
    problemRank: "故障次数排名",
    num: "编号",
    workHour: "工作时长",
    dayilyWorkHour: "每日工作时长",
    hour: "时长",
    useTimeRate: "工作效率",
    driverNum: "驾驶员编号",
    driverName: "驾驶员姓名",
    startTime: "开机时间",
    endTime: "关机时间",
    useRate: "使用率",
    carDayEfficiency: "每日车辆效率",
    todayWorkTime: "今日工时",
    carUseDetail: "车辆使用明细",
    moveTime: "移动时长",
    carryWeightTime: "负载时长",
    freeTime: "空闲时长",
    carryWeightRate: "移动负载效率",
    moveMileage: "行驶里程",
    stopCount: "空滤堵塞次数",
    airStop: "空滤堵塞",
    lowLiquidLevelCount: "低液位",
    lowOilCount: "低油压",
    lowPowerCount: "低电压",
    problemTime: "故障时间",
    eventMessage: "故障类型",
    value: "数量(次)",
    problemCount: "今日故障",
    problemTrend: "故障趋势",
    problemDetail: "故障明细",
    problemProp: "故障占比",
    totalWorkTime: "总工时",
    form: {
      carId: "请输入车辆编号",
    },
    btn: {
    }
  },
  //司机管理
  DriverManagement: {
    manufactureNum: "制造编号",
    carId: "车辆编号",
    plateNum: "车牌号",
    customNum: "自编号",
    orgName: "组织名称",
    terminalId: "终端编号",
    terminalType: "终端型号",
    messageTime: "上报时间",
    linkState: "设备状态",
    onLine: "在线",
    offLine: "离线",
    authorizeCount: "已录入指纹数量",
    authorizes: "授权数量",
    fingers: "指纹数量",
    driverNum: "驾驶证号",
    name: "司机姓名",
    fingerGroup: "指纹编号",
    fingerGroupId: "指纹库编号",
    fingerGroupName: "指纹库名称",
    number: "授权序号",
    authorizeType: "授权类型",
    createTime: "操作日期",
    num: "编号",
    to: "到",
    deny: "否",
    correct: "是",
    fingerAuthorize: "指纹授权",
    keyAuthorize: "钥匙卡授权",
    faceAuthorize: "人脸授权",
    authorizePower: "授权权限",
    normalAuthorize: "普通授权",
    adminAuthorize: "管理员授权",
    authorizeDriver: "授权司机",
    nearTime: "临期",
    normal: "正常",
    exceed: "超期",
    driverExpires: "年审到期日期",
    driverExpiresType: "年审状态",
    remarks: "备注",
    jurisdictionName: "辖区名称",
    nowExpireDate: "当前到期日期",
    changeExpireDate: "变更到期日期",
    auditState: "审批结果",
    auditOpinion: "审批意见",
    driverAnnualSuccess: "司机年审成功",
    driverAnnual: "司机年审",
    approvalProgress: "审批进度",
    filePath: "图片",
    annualAgain: "重新年审",
    isAuth: "是否已授权",
    terminalType: "终端类型",
    addTermianlSetting: "添加终端配置",
    choseTerminal: "选择终端",
    loginName: "关联平台账户",
    linkAccount: "关联账户",
    phone: "电话号码",
    card: "身份证号",
    email: "邮箱",
    rolePower: "角色权限",
    roleData: "数据权限",
    transfer: "驾驶员划拨",
    driverNumBelong: "驾驶证号-归属",
    roleId: "目标位置",
    oldDriverNum: "原驾驶证号",
    newDriverNum: "新驾驶证号",
    fingerNum: "已录入指纹数量",
    work: "工作",
    leisure: "空闲",
    state: "工作状态",
    startTime: "开机时间",
    endTime: "关机时间",
    workHour: "工作时长",
    trainTitle: "培训标题",
    examEndTime: "考试截止日期",
    examDuration: "考试时长",
    examQuestion: "考试题目",
    examDriver: "考试人员",
    examDriverCount: "考试人员数量",
    examPassMark: "考试及格分(100分制)",
    examResult: "考试结果(已通过/考试人数)",
    result: "考试结果",
    noExam: "未考试",
    exam: "已考试",
    noPass: "未通过",
    pass: "通过",
    misssExam: "缺考",
    questionAnswerStr: "答案",
    examStateStr: "考试状态",
    driverExamTime: "考试时间",
    examResult: "考试结果",
    numOrName: "驾驶证号/司机名称",
    fingerBankName: "指纹库名称",
    adminNum: "管理员人数",
    normalNum: "普通人数",
    adminList: "管理员列表",
    normalList: "普通人员列表",
    normalFinger: "普通指纹",
    adminFinger: "管理员指纹",
    fingerBankBelong: "指纹库编号-归属",
    keyNum: "钥匙卡号",
    makeKeyTime: "制卡时间",
    normalPeople: "普通人员",
    adminPeople: "管理人员",
    makeKey: "制卡",
    faceUpdateTime: "人脸图像更新时间",
    faceData: "人脸数据",
    
    teamName: "班组名称",
    teamNumber: "班组编号",
    addTeam: "新建班组",
    editTeam: "修改班组",
    administrativeStaff: "管理人员",
    ordinaryPersonnel: "普通人员",
    teamBelong: "班组编号-归属",
    teamTransfer: "班组划拨",

    form: {
      carId: "请输入车辆编号",
      driverName: "请输入司机姓名",
      terminalType: "请选择终端类型",
      groupId: "请选择终端上传类型",
      keyId: "请选择指令名称",
      terminalId: "请输入终端编号",
      confirmClear: "确定清空吗？",
      clearSuccess: "清空成功",
      confirmSync: "确定同步吗？",
      syncSuccess: "同步成功",
      linkState: "请选择设备状态",
      authorizeType: "请选择授权种类",
      authorizePower: "请选择授权权限",
      driverNum: "请选择授权驾驶员",
      driverNumber: "请输入驾驶证号",
      confirmSyncFinger: "确定同步指纹吗？",
      // syncSuccess: "同步成功",
      changeDriverNum: "修改驾驶证号",
      deliveryTime: "请选择出厂时间",
      addDriverFingerSuccess: "新建指纹成功",
      state: "请选择设备状态",
      trainTitle: "请输入培训标题",
      examEndTime: "请选择考试截止日期",
      examDuration: "请输入答题时长",
      examPassMark: "请输入考试及格分",
      downloadExamPeopleModle: "下载考试人员模板",
      downloadExamQuestionModle: "下载考试题目模板",
      choseFingerNum: "请选择指纹库编码",
      choseDriverNum: "请选择授权驾驶员",
      choseFingerBankName: "请选择指纹库名称",
      choseDriver: "已选驾驶员",
      allDriver: "全部驾驶员",
      chooseDriver: "选择驾驶员",
      fingerBankBelong: "指纹库编号-归属",
      transferFingerBank: "指纹库划拨",
      batchAuth: "批量授权",
      inputAuthType: "请输入授权类型",
      choseAuthType: "请选择授权类型",
      sendContent: "发送内容",
      uploadExamQuestion: "请上传考试题目",
      uploadExamDriver: "请上传考试人员",
    },
    btn: {
      cancelSend: "清空",
      syncDriver: "司机同步",
      synchro: "指纹同步",
      addAuthorize: "新增授权",
      add: "新建驾驶员",
      addKey: "新增制卡",
      edit: "修改驾驶员",
      addDriverFinger: "新建驾驶员指纹",
      addFinger: "新增指纹",
      authFingeBank: "指纹库授权",
      editFinger: "修改指纹",
      addFingerSuccess: "新建指纹成功",
      editFingerSuccess: "修改指纹成功",
      transferFingerBank: "指纹库划拨",
      updateDriverFace: "更新人脸数据",
    }
  },
  //政府监管
  GovernmentRegulation: {
    nowExpireDate: "当前到期日期",
    changeExpireDate: "变更到期日期",
    approve: "审批",
    auditOpinion: "审批意见",
    feedbackContent: "反馈内容",
    feedbackTime: "反馈时间",
    noteTitle: "标题",
    describe: "描述",
    carFilePath: "车辆信息图片",
    sceneFilePath: "现场图片",
    companyReplyMessage: "公司回复信息",
    waitReply: "待回复",
    haveReplied: "已回复",
    haveClosed: "已关闭",
    noteState: "笔记状态",
    carCount: "车辆数量",
    driverCount: "人员数量",
    driverCarRate: "车辆人员比例",
    linkCarCount: "10内上线车辆数",
    onLinkCarCount: "10内未上线车辆数",
    InsufficientManMachineRatio: "人机配比不足",
    SuspectedEquipmentRemoval: "疑似设备拆除",
    emissionRatio: "排放占比",
    safe: "安全",
    noSafe: "不安全",
    safeEquiteRatio: "安全设备比例",
    maintenanceRatio: "保养占比",
    car: "车辆",
    normal: "正常",
    nearTime: "临期",
    exceedTime: "超期",
    checked: "已点检",
    noCheck: "未点检",
    checkRatio: "点检率",
    abnormal: "异常",
    checkAbnormalRatio: "点检异常率",
    overview: "概览",
    carAgeRatio: "车龄占比",
    driverNum: "驾驶员编号",
    name: "驾驶员姓名",
    overloadCount: "超载",
    speedOverCount: "超速",
    safeBelt: "安全带",
    collisionCount: "碰撞",
    leaveFenceCount: "出围栏",
    endTime: "违规时间",
    eventMessage: "违规类型",
    value: "数量(次)",
    violationTrend: "违规趋势",
    noData: "暂无数据",
    violationRatio: "违规占比",
    violationDetail: "违规明细",
    overloadCountVlaue: "超载(次)",
    speedOverCountVlaue: "超速(次)",
    safeBeltVlaue: "安全带(次)",
    collisionCountVlaue: "碰撞(次)",
    leaveFenceCountVlaue: "出围栏(次)",
    eventInterval: "违规时长",
    companyViolationAnalysis: "公司违规分析",
    carViolationDetail: "车辆违规明细",
    carExpiresType: "年审状态",
    insureType: "保险状态",
    safeList: "安全配件",
    brandName: "品牌",
    brandTypeName: "型号",
    type: "动力类型",
    carEmissionName: "排放标准",
    carSaveAddress: "车辆存放地址",
    companyNum: "统一社会信用代码",
    email: "公司邮箱",
    companyAddress: "公司地址",
    driverExpires: "驾驶证到期日期",
    driverExpiresType: "驾驶证状态",
    regulationsContent: "内容",
    issueTime: "发布日期",
    isFilePath: "附件下载",
    filePath: "附件",
    driverAnnualReview: "司机年审",
    carAnnualReview: "车辆年审",
    form: {
      approveResult: "该车辆审批结果",
      pass: "通过",
      noPass: "驳回",
      driverApproveResult: "该司机审批结果",
      lawNotes: "执法笔记",
      companyName: "请输入公司名称",
      companyNum: "请输入统一社会信用代码",
    },
    btn: {
      batchApprove: "批量审批",
    }
  },
  //首页
  HomPage: {
    comStatistics: "综合统计",
    carNum: "车辆总数",
    onTower: "在线台数",
    failTower: "故障台数",
    todayWork: "车辆临期数",
    violaTower: "违规台数",
    violationToday: "今日违规",
    unit: "个",

    annualAudit: "年审审核",
    compliance: "符合",
    insurance: "保险",
    exceedTime: "逾期",
    innerRing: "内环",
    year: "年",
    carAgeRatio: "车龄占比",
    carryingCapacityStatistics: "承载能力统计",
    conform: "符合",
    inconform: "不符合",
    total: "总量",
    forklift: "台",
    vehicleWorkingRate: "车辆工作率",
    checkPassRate: "点检合格率",
    high: "高",
    low: "低",
    shenYang: "沈阳市",
    weather: "天气",
    dynamicStatistics: "动力统计",
    carCount: "车辆总计",
    dieselVehicle: "内燃车",
    electrocar: "电动车",
    cars: "辆",
    AnnualAuditStatistics: "年审统计",
    noData: "暂无数据",
    QingdaoMarketLogisticsEquipmentInformationPlatform: "青岛市场内物流设备信息平台",
    day: "天",
    SafeOperatingDaysOfTheDevice: "设备安全运行天数",
    hour: "小时",
    CumulativeRunningTime: "累计运行时长",
    toggleFullScreen: "全屏/退出全屏",
    backManagement: "管理后台",
    proportionOfNewRegulations: "符合新法规占比",
    newRegulationsCount: "车辆符合新法规总计",
    insuranceCoverage: "保险覆盖率",
    sevenDayVehicleWorkingRate: "七天车辆工作率",
    sevenDayCheckPassRate: "七天点检合格率",
    qingPuArea: "青浦区",
    QingdaoMarketLogisticsEquipmentInformationPlatform: "青浦区场内物流设备信息平台",
    workTime: "工作时长",
    onlineCount: "在线数",
    offLineCount: "离线数",
    carTotal: "车辆总台数",
    overload: "超载",
    speedOver: "超速",
    positionTimeout: "离位超时",
    collision: "碰撞",
    leaveFence: "离开围栏",
    value: "次数",
    ForkliftIntelligentManagementPlatform: "叉车智能管理平台",
    exitFullScreen: "退出全屏",
    fullScreen: "全屏",
    chargeCar: "充电车",
    maintainAdventCar: "保养临期车",
    workCar: "工作车",
    maintainExceedCar: "保养超期车",
    leisureCar: "空闲车",
    licensesAdventValue: "驾驶证临期数",
    todayFault: "今日故障",
    FilterPluggingCount: "空滤堵塞",
    LowOilPressureCount: "低油压",
    LowPowerCount: "低电压",
    LowLiquidLevelCount: "低液位",
    todayCarWorkTimeRank: "今日车辆工作时长排名(TOP10)",
    todayDriverWorkTimeRank: "今日驾驶员工作时长排名(TOP10)",

    form: {
      yourBrowserDoesNotSupportFullScreen: "你的浏览器不支持切全屏",
    },
    btn: {
    }
  },
  //平台设置
  PlatformSettings: {
    checkName: "点检名称",
    operate: "操作",
    brandManagement: "品牌管理",
    brandName: "品牌名称",
    type: "型号",
    orgDetail: "组织详情",
    superId: "上级ID",
    lowerNum: "下级数量",
    level: "等级",
    userName: "用户名",
    loginName: "账号",
    name: "名称",
    email: "邮箱",
    phone: "手机号",
    subscribe: "订阅",
    operate: "操作",
    reportSend: "报表推送",
    dailyReport: "日报",
    weekReport: "周报",
    monthReport: "月报",
    dailyMonthReport: "每日月报",
    roleName: "角色名称",
    roleUserNum: "用户数量",
    listSet: "列配置",
    menu: "平台页面权限",
    appMenu: "APP页面权限",
    menuDetail: "菜单详情",
    role: "角色",
    phone: "电话",
    expiryDate: "每日月报",
    dailyMonthReport: "有效日期",
    loginCount: "登录次数",
    rolePower: "角色权限",
    roleData: "数据权限",
    system: "系统",
    englishName: "英文名称",
    chineseName: "中文名称",
    typesOf: "类型",
    icon: "图标",
    routingAddress: "路由地址",
    form: {
      sendSuccess: "发送成功",
      cancelSuccess: "取消成功",
      editSortFail: "排序修改失败",
      addCheckSuccess: "新建点检成功",
      editCheckSuccess: "修改点检成功",
      addBrand: "新建品牌",
      editBrand: "修改品牌",
      addBrandSuccess: "新建品牌成功",
      editBrandSuccess: "修改品牌成功",
      addTypeSuccess: "新建型号成功",
      editTypeSuccess: "修改型号成功",
      roleName: "请输入角色名称",
      addRoleSuccess: "新建角色成功",
      editRoleSuccess: "修改角色成功",
      editUserSuccess: "修改用户成功",
      inputCheckName: "点检名称为空"
    },
    btn: {
      loginName: "请输入账号",
      email: "请输入邮箱",
      userName: "请输入用户名",
      role: "请选择角色",
      rolePower: "请选择角色权限",
      expiryDate: "请选择有效日期",
      pleaseSelectSystem: "请选择系统",
      pleaseEnterEnglishName: "请输入英文名称",
      pleaseEnterChineseName: "请输入中文名称",
      pleaseSelectType: "请选择类型",
      pleaseSelectSorting: "请选择排序",
      pleaseEnterAddress: "请输入路由地址",
    }
  },
  //安全管理
  SafeManagement: {
    TabRemind: "点检提醒",
    TabAnalysis: "点检分析",
    TabReportForm: "点检报表",
    Checked: "已检",
    Unchecked: "未检",
    stop: "停机检修",
    stoped: "停用",
    spotCheckDate: "上次点检日期",
    spotCheckType: "点检状态",
    carUseState: "车辆使用状态",
    happenTime: "点检日期",
    InspectionResults: "点检结果",
    InspectionPersonnel: "点检人",
    abnormalState: "异常状态",
    checkRatio: "点检率",
    checkAbnormalRatio: "点检异常率",
    queryCheckRecord: "点检记录查询",
    checkName: "点检名称",
    carMileage: "公里数",
    check: "点检",
    resubmissions: "补交",
    totalWorkTime: "总工时",
    fenceName: "围栏名称",
    centerLng: "经度",
    centerLat: "纬度",
    radius: "半径",
    level: "层级",
    serialNumber: "命令流水号",
    terminalTypeName: "终端类型",
    terminalType: "终端指令类型",
    aliKey: "指令种类",
    keyName: "指令名称",
    sendContent: "指令内容",
    receivedTime: "送达时间",
    state: "状态",
    sending: "发送中",
    exceedFail: "过期失败",
    success: "成功",
    uploadTerminalType: "终端上传类型",
    serverSet: "服务设置",
    voiceSet: "语音调度",
    setNum: "调度次数",
    wifiName: "WIFI名称",
    wifiPassWord: "WIFI密码",
    initializePassWord: "初始化密码",
    idNum: "ID号",
    retry: "重试",
    eventMessage: "报警事件类型",
    eventValue: "数值",
    startTime: "事件开始时间",
    endTime: "事件结束时间",
    alarmType: "报警类型",
    illegalType: "违规类型",
    form: {
      carUseState: "请选择车辆使用状态",
      checkSuccess: "点检成功",
      queryReport: "查看报表",
      ThereAreAbnormalItemsInTheProjectYouSubmittedWhetherToSubmit: "您提交的项目中有异常项，请在备注中填写异常原因再提交",
      addFence: "创建围栏",
      editFence: "修改围栏",
      addFenceSuccess: "新增围栏成功",
      editFenceSuccess: "修改围栏成功",
      selectServerSet: "请选择服务设置",
      retrySuccess: "重试成功",
      uploadTerminalType: "选择终端上传类型",
      selectTerminal: "选择终端",
      importTerminal: "导入终端",
      uploadTerminalFile: "上传终端文件",
      chooseKeyName: "请选择指令名称",
      chooseServer: "请选择服务",
      importVoiceSet: "请输入语音调度",
      importSetNum: "请输入调度次数",
      importWifiName: "请输入WIFI名称",
      importWifiPassWord: "请输入WIFI密码",
      importInitializePassWord: "请输入初始化密码",
      alarmType: "请选择报警类型",
      illegalType: "请选择违规类型",
    },
    btn: {
      spotCheck: "点检",
      addSimpleSet: "新建简单配置",
      addComPlexSet: "新建复杂配置",
      downloadModle: "下载模板",
      addTerminalSet: "添加终端配置",
      retrySetOrder: "重试配置指令",
    }
  },
  //车辆管理
  VehicleManagement: {
    basicInformation: "基础信息",
    generate: "生成",
    engineNo: "发动机号",
    storageAddress: "存放地址",
    vehicleModelInformation: "车型资料",
    vehicleEmissions: "车辆排放",
    combustionEngine: "内燃机",
    motor: "电动机",
    sizeInformation: "尺寸信息",
    length: "长度",
    width: "宽度",
    height: "高度",
    forkLength: "货叉长度",
    portalNum: "门架节数",
    maxLift: "最大起升",
    clampRange: "夹抱范围",
    maintenanceInformation: "保养信息",
    isMaintain: "是否保养",
    deny: "否",
    correct: "是",
    reminderCycle: "提醒周期",
    serviceInterval: "保养周期",
    accessoriesInformation: "配件信息",
    selectAll: "全选",
    belongTo: "归属",
    targetPosition: "目标位置",
    originalTerminalNumber: "原终端编号",
    newTerminalNumber: "新终端编号",
    originalVehicleNumber: "原车辆编号",
    newVehicleNumber: "新车辆编号",
    currentExpirationDate: "当前到期日期",
    annualReviewName: "年审机构名称",
    annualReviewCode: "年审注册代码",
    changeExpireDate: "变更到期日期",
    picture: "图片",
    reAnnualReview: "重新年审",

    voltage: "电压",
    speed: "速度",
    carryWeight: "载重",
    address: "地址",
    state: "状态",
    province: "省份",
    city: "城市",
    maintenancePerson: "维修人员",
    syncState: "同步状态",
    powerType: "动力类型",
    terminalBindDate: "终端绑定日期",
    brandModel: "品牌型号",
    insureStartTime: "保险开始日期",
    insureEndTime: "保险结束日期",
    isInsureFilePath: "保险附件",
    isInsureState: "保险状态",
    materialName: "物料名称",
    num: "数量",
    amount: "金额",
    repairMaterialCost: "维修物件费用",
    repairCostRate: "维修费用占比率",
    maintainCostRate: "保养费用占比率",
    yuan: "元",
    moneyYuan: "金额(元)",
    unitPrice: "单价(元)",
    serialNumber: "业务流水号",
    carWorkTime: "车辆累计工作时间",
    repairPerson: "报修人",
    repairTime: "报修时间",
    phone: "联系电话",
    situationDescription: "情况描述",
    urgeCount: "催单次数",
    repairStateStr: "是否维修",
    state: "状态",
    unFinish: "未完成",
    finish: "已完成",
    maintain: "维修",
    remind: "催单",
    repairBill: "报修单",
    maintainBill: "维修单",
    operateUser: "维修人",
    operateTime: "维修时间",
    repairType: "故障项目",
    peopleCost: "人工费用",
    repariContent: "维修内容",
    serialContent: "保养内容",
    totalMoneny: "总计费用（元）:",
    other: "其他",
    airStop: "空滤堵塞",
    lowLiquidLevelCount: "低液位",
    lowOilCount: "低油压",
    lowPowerCount: "低电压",
    serialPerson: "保养人员",
    serialTime: "保养时间",
    materialCost: "物料总费用",
    workTime: "累计工作时间",
    nextMaintainTime: "下次保养时间",
    maintainCycle: "保养周期",
    maintainReminder: "保养提醒",
    lastMaintainTime: "上次保养时间",
    serial: "保养",
    serialBill: "保养单",
    unapproved: "未审批",
    passed: "已通过",
    rejected: "已驳回",
    on: "开机",
    off: "关机",
    noSync: "未同步",
    fail: "失败",
    success: "成功",
    phone: "电话号码",
    baseInform: "基本信息",
    card: "身份证号",
    driverExpires: "驾驶证到期时间",
    workHour: "工作时长",
    openTime: "开机时间",
    closeTime: "关机时间",
    firmwareVersion: "固件版本",
    terminalType: "终端类型",
    simIccicd: "ICCID号",
    simNumber: "SIM卡号",
    deliveryTime: "出厂时间",
    baseData: "基本资料",
    motorNum: "发动机号",
    carTypeData: "车型资料",
    brandId: "品牌",
    brandTypeId: "型号",
    carType: "车型",
    capacity: "承载力",
    carInfom: "车辆信息",
    termianlInform: "终端信息",
    driverInform: "司机信息",
    carWorkStatus: "车辆工作情况",
    runningData: "运行数据",
    offlineDuration: "离线时长",
    deviceStatus: "设备状态",
    workCondition: "工作状态",
    faultConditions: "故障状态",
    oneTwo: "0-1天",
    oneThree: "1-3天",
    threeSeven: "3-7天",
    sevenTen: "7-10天",
    ten: "10+天",
    fault: "故障",
    faultItems: "故障项目",
    maintenanceTime: "维修时间",
    carList: "全部车辆",
    selectedCar: "已选车辆",
    entryName: "项目名称",
    projectDescription: "项目描述",
    newProject: "新建项目",
    modifyProject: "修改项目",
    maintenanceSuggestions: "保养建议",
    partName: "零件名称",
    form: {
      imputCarid: "请输入车辆编号",
      repairPerson: "请输入报修人",
      repairTime: "请选择报修时间",
      phone: "请输入联系电话",
      serialNumber: "请输入报修单流水号",
      maintainPerson: "请输入维修人",
      maintainTime: "请选择维修时间",
      chooseFaultItem: "请选择故障项目",
      confirmRemind: "确定催单吗？",
      remindSuccess: "催单成功",
      confirmFinish: "确定完成吗？",
      finishSuccess: "确认完成",
      repairType: "请选择故障类型",
      haveBeenRepaired: "已维修",
      noClick: "未维修不能点击！",
      imputMaintainPerson: "请输入保养人",
      chooseMaintainTime: "请选择保养时间",
      chooseMaintainType: "请选择保养类型",
      carAnnualAuditSuccess: "车辆年审成功",
      manufactureNum: "请输入制造编号",
      brandId: "请选择品牌",
      brandTypeId: "请选择型号",
      type: "请选择动力车型",
      capacity: "请输入承载力",
      deliveryTime: "请选择出厂日期",
      carEmissionId: "请选择年审到期日期",
      thereIsNoMotionTrajectoryInTheCurrentTimePeriod: "当前时间段没有运动轨迹",
    },
    btn: {
      addNewLine: "新增一行",
      startPlayBack: "开始回放",
      continuePlayBack: "继续回放",
      stopPlayBack: "暂停回放",
      modifyVehicleNumber: "修改车辆编号",
      bindTerminal: "绑定终端",
      replaceTerminal: "替换终端",
      vehicleAllocation: "车辆划拨",
      approvalProgress: "审批进度",
      vehiclePosition: "车辆定位",
    }
  },
};
